import { useEffect, useState } from "react";
import projects_bg from "../../../Assets/Home/projects_bg.png";
import { PROJECT_IMAGE_1, PROJECT_IMAGE_2 } from "../../../utils/constants";
import { getCloudinaryImageUrl } from "../../../utils/getCloudinaryImageUrl";
import Button from "../Common/Button";
import api from "../../../configs/api";
import { useNavigate } from "react-router-dom";

export default function MixMastersProjects() {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const fetchProjects = async () => {
    try {
      setLoading(true);

      const res = await api.get("/projects?page=1&limit=4");

      const { projects } = res.data.data;
      setProjects(projects);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    if (!projects.length || isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % projects.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [projects, isPaused]);

  return (
    <div className="w-full relative md:py-10 py-6 bg-[#0C0009] overflow-hidden">
      {" "}
      <div
        className="absolute inset-0 opacity-20 pointer-events-none bg-fixed bg-center bg-cover"
        style={{
          backgroundImage: `url(${projects_bg})`,
        }}
      />
      <div className="absolute inset-0 bg-black/60 pointer-events-none" />
      <div className="px-4 z-10 md:px-8 lg:px-10">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-8 lg:mb-10">
          <div>
            <p
              data-aos="fade-up"
              className="text-xs font-semibold tracking-widest uppercase mb-4"
              style={{ color: "#e040fb", letterSpacing: "0.18em" }}
            >
              [RECENT WORKS]
            </p>

            <h2
              data-aos="fade-up"
              data-aos-delay="100"
              className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wide text-white font-heading leading-relaxed"
            >
              EXPLORE OUR
              <br />
              EXCELLENCE PROJECTS
            </h2>
          </div>

          <div
            data-aos="fade-left"
            data-aos-delay="200"
            className="flex sm:justify-end items-center"
          >
            <Button
              onClick={() => {
                navigate("/projects");
                window.scrollTo({ top: "0", behavior: "smooth" });
              }}
              text={"View All"}
            />
          </div>
        </div>

        <hr className="project-divider mb-8 lg:mb-10" />

        {/* Project 1 */}
        <div
          className="overflow-hidden w-full"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            className="flex transition-transform duration-1000 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
            }}
          >
            {projects?.map((project, i) => (
              <div
                onClick={() => {
                  navigate(`/projects/${project?._id}`);
                  window.scrollTo({ top: "0", behavior: "smooth" });
                }}
                key={i}
                className="w-full flex-shrink-0 flex flex-col lg:flex-row gap-4 lg:gap-10 items-center mb-10 lg:mb-14 px-1 md:px-0"
              >
                {/* Image */}
                <div
                  className="rounded-2xl overflow-hidden w-full lg:flex-shrink-0 lg:w-[850px]"
                  style={{ height: "450px", maxHeight: "550px" }}
                >
                  <img
                    src={project?.images?.[0]}
                    alt={project?.name}
                    className="h-full w-full object-cover"
                  />
                </div>

                {/* Content */}
                <div className="flex-1 w-full">
                  <h3 className="font-semibold font-bebas text-2xl md:text-3xl lg:text-4xl tracking-widest uppercase text-white mb-3">
                    {project?.name}
                  </h3>

                  <p className="text-gray-400 text-sm mb-6">
                    {project?.description}
                  </p>

                  <ul className="list-disc list-inside space-y-2">
                    {project?.features?.map((feature, index) => (
                      <li key={index} className="text-white">
                        <span className="text-sm font-medium">
                          {feature?.heading}:
                        </span>
                        <span className="text-gray-400 text-xs ml-2">
                          {feature?.description}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <div
                    onClick={() => {
                      navigate(`/projects/${project?._id}`);
                      window.scrollTo({ top: "0", behavior: "smooth" });
                    }}
                    className="mt-4 cursor-pointer text-sm font-semibold"
                    style={{ color: "#e86060" }}
                  >
                    View Details →
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Project 2 */}
        <div
          className="overflow-hidden w-full"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            className="flex transition-transform duration-1000 ease-in-out"
            style={{
              transform: `translateX(-${(projects.length - 1 - currentIndex) * 100}%)`,
            }}
          >
            {projects.map((project, i) => (
              <div
                onClick={() => {
                  navigate(`/projects/${project?._id}`);
                  window.scrollTo({ top: "0", behavior: "smooth" });
                }}
                key={i}
                className="w-full flex-shrink-0 flex flex-col lg:flex-row gap-4 lg:gap-10 items-center mb-10 lg:mb-4 px-1 md:px-0"
              >
                {/* Content */}
                <div className="flex-1 w-full order-2 md:order-1">
                  <h3 className="font-semibold font-bebas text-2xl md:text-3xl lg:text-4xl tracking-widest uppercase text-white mb-3">
                    {project?.name}
                  </h3>

                  <p className="text-gray-400 text-sm mb-6">
                    {project?.description}
                  </p>

                  <ul className="list-disc list-inside space-y-2">
                    {project?.features?.map((feature, index) => (
                      <li key={index} className="text-white">
                        <span className="text-sm font-medium">
                          {feature?.heading}:
                        </span>
                        <span className="text-gray-400 text-xs ml-2">
                          {feature?.description}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <div
                    onClick={() => {
                      navigate(`/projects/${project?._id}`);
                      window.scrollTo({ top: "0", behavior: "smooth" });
                    }}
                    className="mt-4 cursor-pointer text-sm font-semibold"
                    style={{ color: "#e86060" }}
                  >
                    View Details →
                  </div>
                </div>
                {/* Image */}
                <div
                  className="rounded-2xl order-1 md:order-2 overflow-hidden w-full lg:flex-shrink-0 lg:w-[850px]"
                  style={{ height: "450px", maxHeight: "550px" }}
                >
                  <img
                    src={project?.images?.[0]}
                    alt={project?.name}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
